import { IonText } from '@ionic/react';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { syncTimer } from '../../common/interval';
import { getStateStringAsDate, padLeft } from '../../common/util';
import { ClockingDirection } from '../../models/dms/clocking.model';
import store from '../../store';
import { useAppSelector } from '../../store/hooks';

interface IComponentProps {
  showSeconds?: boolean;
}

const LabourTimer: React.FC<IComponentProps> = ({ showSeconds = true }) => {
  const [labourHours, setLabourHours] = useState('00');
  const [labourMinutes, setLabourMinutes] = useState('00');
  const [labourSeconds, setLabourSeconds] = useState('00');

  const { labourClocking } = useAppSelector(state => state.technicianClocking);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const { isDemo } = store.getState().app;
        const { labourClocking } = store.getState().technicianClocking;

        const endDate = labourClocking?.startDateTime ? getStateStringAsDate(labourClocking.startDateTime) : new Date();
        let now = new Date();

        // Demo
        if (isDemo) {
          now = moment().set({ hour: 10, minute: 30, second: 32 }).toDate();
        }

        let diff = Math.abs(+endDate - +now);

        let hours = Math.floor(diff / 3.6e6);
        let minutes = Math.floor((diff % 3.6e6) / 6e4);
        let seconds = Math.floor((diff % 6e4) / 1000);

        switch (labourClocking?.direction) {
          case ClockingDirection.On:
            setLabourHours(padLeft(hours));
            setLabourMinutes(padLeft(minutes));
            setLabourSeconds(padLeft(seconds));
            break;
          case ClockingDirection.Break:
            now = labourClocking?.endDateTime ? getStateStringAsDate(labourClocking.endDateTime) : new Date();
            diff = Math.abs(+endDate - +now);

            hours = Math.floor(diff / 3.6e6);
            minutes = Math.floor((diff % 3.6e6) / 6e4);
            seconds = Math.floor((diff % 6e4) / 1000);

            setLabourHours(padLeft(hours));
            setLabourMinutes(padLeft(minutes));
            setLabourSeconds(padLeft(seconds));
            break;
          default:
            setLabourHours('00');
            setLabourMinutes('00');
            setLabourSeconds('00');
            break;
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonText color={labourClocking?.direction === ClockingDirection.On ? 'success' : 'warning'} class="ion-text-nowrap ion-align-self-center">
      <h1 className="time-duration ion-no-margin">{labourHours}:</h1>
      <h1 className="time-duration ion-no-margin">{labourMinutes}</h1>
      {showSeconds && <h1 className="time-duration time-duration-seconds ion-no-margin">{labourSeconds}</h1>}
    </IonText>
  );
};

export default LabourTimer;